export const COMPANY_NAME = "KINGS SHOPS PACIFIC MANAGER LLC";
export const COMPANY_SHORT = "Kings Shops Pacific Manager";
export const COMPANY_INITIALS = "KSP";
export const COMPANY_ADDRESS_FULL = "2029 Century Park E, Los Angeles, California, US 90067-2901";
export const COMPANY_LOCATION = "Los Angeles, California";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=2029%20Century%20Park%20E%2C%20Los%20Angeles%2C%20California%2C%20US%2090067-2901";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory listing" },
  { "label": "Region", "value": "Los Angeles County" },
  { "label": "Location", "value": "Los Angeles, California" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "KINGS SHOPS PACIFIC MANAGER LLC" },
  { "label": "Location", "value": "Los Angeles, California" },
  { "label": "Address", "value": "2029 Century Park E, Los Angeles, California, US 90067-2901" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "TODO: Pillar 1", "body": "TODO: Customize." },
  { "icon": "✦", "title": "TODO: Pillar 2", "body": "TODO: Customize." },
  { "icon": "✿", "title": "TODO: Pillar 3", "body": "TODO: Customize." },
  { "icon": "❍", "title": "TODO: Pillar 4", "body": "TODO: Customize." },
];
